import apiFetch from '../apiFetch'

export default function (token, body) {
  return apiFetch({ endPoint: 'role/filter', method: 'POST', body: body, token: token })
}
